import { render, staticRenderFns } from "./OnuUnregistered.vue?vue&type=template&id=16860dd0&scoped=true&"
import script from "./OnuUnregistered.vue?vue&type=script&lang=js&"
export * from "./OnuUnregistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16860dd0",
  null
  
)

export default component.exports